import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-three',
  templateUrl: './funfacts-style-three.component.html',
  styleUrls: ['./funfacts-style-three.component.scss']
})
export class FunfactsStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
